import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.define-properties";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 */
import React, { useState, useContext, useCallback } from 'react';
import CoreSettingsContext from 'wfui-digital-core/es/CoreSettingsContext';
import globals from '../../lib/globals/globals';
import SettingsContext from './SettingsContext';

var SettingsProvider = function SettingsProvider(_ref) {
  var children = _ref.children;
  var coreSettings = useContext(CoreSettingsContext);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      applicationReady = _useState2[0],
      setApplicationReady = _useState2[1];

  var _useState3 = useState(globals().useMobileStickyFooter || false),
      _useState4 = _slicedToArray(_useState3, 2),
      useMobileStickyFooter = _useState4[0],
      setUseMobileStickyFooter = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      showMobileStickyFooter = _useState6[0],
      setShowMobileStickyFooter = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      forceMobileStickyFooter = _useState8[0],
      setForceMobileStickyFooter = _useState8[1];

  var _useState9 = useState(globals().useAltMasthead || false),
      _useState10 = _slicedToArray(_useState9, 2),
      useAltMasthead = _useState10[0],
      setUseAltMasthead = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      debugFocus = _useState12[0],
      setDebugFocus = _useState12[1];

  var _useState13 = useState(globals().hideMobileMastheadMenus),
      _useState14 = _slicedToArray(_useState13, 2),
      hideMobileMastheadMenus = _useState14[0],
      setHideMobileMastheadMenus = _useState14[1];

  var _setShowMobileStickyFooter = function _setShowMobileStickyFooter(show) {
    setShowMobileStickyFooter(show);
    !show && setForceMobileStickyFooter(false);
  };

  var context = _objectSpread({
    applicationReady: applicationReady,
    setApplicationReady: useCallback(function () {
      return setApplicationReady(true);
    }, []),
    useMobileStickyFooter: useMobileStickyFooter,
    setUseMobileStickyFooter: setUseMobileStickyFooter,
    showMobileStickyFooter: showMobileStickyFooter,
    setShowMobileStickyFooter: _setShowMobileStickyFooter,
    forceMobileStickyFooter: forceMobileStickyFooter,
    setForceMobileStickyFooter: setForceMobileStickyFooter,
    debugFocus: debugFocus,
    setDebugFocus: setDebugFocus,
    useAltMasthead: useAltMasthead,
    setUseAltMasthead: setUseAltMasthead,
    hideMobileMastheadMenus: hideMobileMastheadMenus,
    setHideMobileMastheadMenus: setHideMobileMastheadMenus
  }, coreSettings);

  return /*#__PURE__*/React.createElement(SettingsContext.Provider, {
    value: context
  }, children);
};

export default SettingsProvider;